import { Icons, IconsList } from "@ppb/the-wall-icons/GenericIcon/GenericIcon";

const SELECTION_TYPE_ICONS: Record<string, Icons> = {
  "FULL_TIME_RESULT_-_2_UP": IconsList.TWO_UP_EARLY_PAYOUT_MONOCHROME,
};

/**
 * Returns the monochrome icon for the given selection type.
 *
 * @param [marketType] - the market type.
 * @param [isSuperSub] - true if superSub is enabled.
 * @returns The icon for the given selection type.
 */
export const getSelectionTypeIcon = (marketType?: string, isSuperSub = false): Icons | undefined => {
  if (!marketType) {
    return undefined;
  }

  return isSuperSub ? IconsList.SUPER_SUB_MONOCHROME : SELECTION_TYPE_ICONS[marketType];
};
